var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('LoadLayout',[_c('BaseLoading')],1):_c('MainLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }